import { AppRouteProps } from "@harea/component";
import React from "react";

const PaybackListContainer = React.lazy(() => import("./container/PaybackListContainer"));

export const PaybackRoutes = [
    {
        path: "paybacks",
        element: <PaybackListContainer />,
        title: "std_payback",
    },
] as Array<AppRouteProps>;
